import(/* webpackMode: "eager" */ "/home/frontru/aquaart-group/src/app/error.tsx");
